import { __decorate, __metadata } from 'tslib';
import { EventEmitter, Input, Output, Component, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';

let UiCButtonComponent = class UiCButtonComponent {
    constructor() {
        this.dataCyName = '';
        this.fill = "solid";
        this.continue = new EventEmitter();
    }
    continueBtn() {
        this.continue.emit();
    }
};
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCButtonComponent.prototype, "color", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCButtonComponent.prototype, "dataCyName", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCButtonComponent.prototype, "disabled", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCButtonComponent.prototype, "mode", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCButtonComponent.prototype, "expand", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCButtonComponent.prototype, "iconMode", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCButtonComponent.prototype, "fill", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCButtonComponent.prototype, "continue", void 0);
UiCButtonComponent = __decorate([
    Component({
        selector: 'ui-c-button',
        template: "<ion-button [ngClass]=\"!!iconMode ? 'ion-button btn-icon '+iconMode+'' : !!mode ? 'ion-button btn-text' : 'ion-button'\"\n  [expand]=\"expand\" [disabled]=\"disabled\" [fill]=\"fill\" [color]=\"color\" data-cy=\"{{dataCyName}}\"\n  (click)=\"continueBtn()\">\n  <ng-content></ng-content>\n  <ng-container *ngIf=\"!!iconMode && iconMode != 'none'\">\n    <ion-icon class=\"ion-icon\" [name]=\"iconMode\"></ion-icon>\n  </ng-container>\n</ion-button>\n",
        styles: [""]
    }),
    __metadata("design:paramtypes", [])
], UiCButtonComponent);

let UiCButtonModule = class UiCButtonModule {
};
UiCButtonModule = __decorate([
    NgModule({
        declarations: [UiCButtonComponent],
        imports: [
            IonicModule,
            CommonModule
        ],
        exports: [UiCButtonComponent],
        schemas: [
            CUSTOM_ELEMENTS_SCHEMA
        ]
    })
], UiCButtonModule);

export { UiCButtonComponent, UiCButtonModule };
//# sourceMappingURL=wlp-ui-c-button.js.map
